import React from "react";
import { useDispatch } from "react-redux";
import { Icon } from "rhombus-react";
import { push } from "connected-react-router";

export default function ContentFeedRefresh({ contentFeedId, contentFeedName, creativeCount, libraryId }) {
	const dispatch = useDispatch();

	const handleRefresh = () => {
		dispatch(push({
			pathname: `/library/${libraryId}/content-feeds/modal/refresh/${contentFeedId}/`,
			state: {
				contentFeedName,
				creativeCount,
			},
		}));
	};

	return (
		<Icon
			name="fas fa-sync-alt"
			className="bounce-circle"
			data-tip="Refresh Bulk Sheet"
			onClick={handleRefresh}
		/>
	);
}

ContentFeedRefresh.displayName = "ContentFeedRefresh";

